import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { parse } from '@fortawesome/fontawesome-svg-core';

const Pollmodal = ({show, onClose, userId, onSubmitPoll, fetchinputs,
  inputData,vote}) => {
    const [project, setProject] = React.useState('');
    const [wing, setWing] = React.useState('');
    const [question, setQuestion] = React.useState('');
    const [options, setOptions] = React.useState(['', '']); // Start with 2 empty options
    const [expiryDate, setExpiryDate] = React.useState('');
    const [projectError, setProjectError] = React.useState('');
    const [wingError, setWingError] = React.useState('');
    const [questionError, setQuestionError] = React.useState('');
    const [optionError, setOptionError] = React.useState('');
    const [expiryError, setExpiryError] = React.useState('');
    const [filteredWings, setFilteredWings] = React.useState([])
    const [loading, setLoading] = React.useState(false);
     
    const uniqueProjects = Array.from(
    new Map(
      inputData.map(item => [
        item.projectId,
        { id: item.projectId, name: item.projectName }
      ])
    ).values()
  )
    const handleProjectChange = e => {
    const selectedProjectId = e.target.value
    setProject(selectedProjectId)
    setProjectError('')
    setWing('')

    const wings = inputData.filter(
      item => String(item.projectId) === String(selectedProjectId)
    )

    setFilteredWings(wings)
  }

    const handleWingChange = e => {
    setWing(e.target.value)
    if (e.target.value) setWingError('')
  }

    const handleQuestionChange = (e) => {
      const value = e.target.value;
      setQuestion(value);
      if (value.trim() === '') {
        setQuestionError('Question cannot be empty.');
      } else {
        setQuestionError('');
      }
    };

    const handleOptionChange = (index, value) => {
      const newOptions = [...options];
      newOptions[index] = value;
      
      // Auto-add a new option when user fills ANY option that is the last one
      
      if (index === newOptions.length - 1 && value.trim() !== '') {
        if (newOptions.length < 6) { // Limit to 6 options
          newOptions.push('');
        }
      }
      
      setOptions(newOptions);

      // Clear error when option is filled
      if (newOptions.some(opt => opt.trim() !== '')) {
        setOptionError('');
      }
    };

    const removeOption = (index) => {
      if (options.length > 2) {
        const newOptions = options.filter((_, i) => i !== index);
        setOptions(newOptions);
      }
    };

    const handleExpiryChange = (e) => {
      const value = e.target.value;
      setExpiryDate(value);
      if (!value) {
        setExpiryError('Please select an future expiry date/time.');
        return;
      }
      
        const selectedDate = new Date(value);
        const now = new Date();
        if (selectedDate.getTime() <= now.getTime()) {
          setExpiryError('Expiry date/time must be in the future.');
        } else {
          setExpiryError('');
        }
    };

    //format date
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    if (!show)  return null;

    const handleSubmit = (e) => {
        e.preventDefault();


        if (project === '') {
          setProjectError('Project is required.');
          return;
        }

        if (wing === '') {
          setWingError('Wing is required.');
          return;
        }
        
        if (question.trim() === '') {
          setQuestionError('Question cannot be empty.');
          return;
        }

        const filledOptions = options.filter(opt => opt.trim() !== '');
        if (filledOptions.length < 2) {
          setOptionError('Please add at least 2 options.');
          return;
        }

        if (!expiryDate ||  expiryError) {
          setExpiryError('Please select a valid future expiry date/time.');
          return;
        }

        const token = localStorage.getItem('token');

        const votepayload = {
          ProjectID: parseInt(project),
          Wing: wing,
          Data: {
            Question: question,
            Options: filledOptions,
            ExpiryDateTime: formatDate(expiryDate)
          }
        };

        setLoading(true);
        onSubmitPoll(votepayload);
        
        // Reset form
        setTimeout(() => {
          setProject('');
          setWing('');
          setQuestion('');
          setOptions(['', '']);
          setExpiryDate('');
          setProjectError('');
          setWingError('');
          setQuestionError('');
          setOptionError('');
          setExpiryError('');
          setLoading(false);
        }, 5000);
        
        return;
    };


  return (
    <>
    <div className='modal-backdrop show' style={{
       backgroundColor: "rgba(255, 255, 255, 0.1)", /* NOT black */
       backdropFilter: "blur(20px) saturate(180%)",
       WebkitBackdropFilter: "blur(10px)",
    }}></div>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title text-bold fs-3">Create New Poll</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>

              <div className="modal-body">
                {/* Project dropdown */}
                <div className="mb-3">
                  <label className="form-label">
                    Select Project <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={project}
                    onChange={handleProjectChange}
                  >
                    <option value="">Choose Project</option>
                    {uniqueProjects.map(p => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {projectError && (
                    <div className="alert alert-danger mt-2">
                      {projectError}
                    </div>
                  )}
                </div>

                {/* Wing dropdown */}
               <div className="mb-3">
                  <div className="mb-3">
                  <label className="form-label">
                    Select Wing <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={wing}
                    onChange={handleWingChange}
                    disabled={!project}
                  >
                    <option value="">Choose Wing</option>
                    {filteredWings.map(w => (
                      <option key={w.wingId} value={w.wingName}>
                        {w.wingName}
                      </option>
                    ))}
                  </select>
                  {wingError && (
                    <div className="alert alert-danger mt-2">{wingError}</div>
                  )}
                </div>
                </div>
                {/* Question input */}
                <div className="mb-3">
                  <label className="form-label text-bold">Questions</label> <span style={{color: 'red'}}>*</span>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Ask Question"
                    value={question}
                    maxlenth="1000"
                    onChange={handleQuestionChange}
                    required
                  />
                  {questionError && <div className="alert alert-danger mt-2">{questionError}</div>}
                </div>
                
                {/* Options input */}
                <div className="mb-3 text-bold">
                  <label className="form-label font-bold">Options</label> <span style={{color: 'red'}}>*</span>
                  {options.map((option, index) => (
                    <div key={index} className="d-flex gap-2 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Option ${index + 1}`}
                        value={option}
                        onChange={(e) => handleOptionChange(index, e.target.value)}
                      />
                      {options.length > 2 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeOption(index)}
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  ))}
                  {optionError && <div className="alert alert-danger mt-2">{optionError}</div>}
                </div>

                {/* Expiry Date/Time input */}
                <div className="mb-3">
                  <label className="form-label text-bold">Poll Expiry Date & Time</label> <span style={{color: 'red'}}>*</span>
                  <input
                    type="datetime-local"
                    className="form-control"
                    value={expiryDate}
                    onChange={handleExpiryChange}
                    required
                  />
                  {expiryError && <div className="alert alert-danger mt-2">{expiryError}</div>}
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>

            </form>

          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
      </>
  );
};


export default Pollmodal;
